import { _ as _toConsumableArray } from '../../../dist/toConsumableArray-0ccd58b7.esm.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-9cc1acb2.esm.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.reduce.js';
import { persist } from 'zustand/middleware';
import create from 'zustand/vanilla';
import { c as createStorage, n as noopStorage } from '../../../dist/storage-057d54ab.esm.js';
import { a as isClient, i as isMobile, b as isIos, d as isAndroid } from '../../../dist/browser-30da4b11.esm.js';
import { _ as _createForOfIteratorHelper } from '../../../dist/createForOfIteratorHelper-27ce1999.esm.js';
import '../../../dist/unsupportedIterableToArray-7c30dadf.esm.js';
import '../../../dist/objectSpread2-04e3d2b4.esm.js';
import '../../../dist/defineProperty-6a97efcd.esm.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.includes.js';

var methodsList = [
// modern browsers
{
  requestFullscreen: 'requestFullscreen',
  exitFullscreen: 'exitFullscreen',
  fullscreenElement: 'fullscreenElement',
  fullscreenEnabled: 'fullscreenEnabled',
  fullscreenchange: 'fullscreenchange',
  fullscreenerror: 'fullscreenerror'
},
// new WebKit
{
  requestFullscreen: 'webkitRequestFullscreen',
  exitFullscreen: 'webkitExitFullscreen',
  fullscreenElement: 'webkitFullscreenElement',
  fullscreenEnabled: 'webkitFullscreenEnabled',
  fullscreenchange: 'webkitfullscreenchange',
  fullscreenerror: 'webkitfullscreenerror'
},
// old WebKit
{
  requestFullscreen: 'webkitRequestFullScreen',
  exitFullscreen: 'webkitCancelFullScreen',
  fullscreenElement: 'webkitCurrentFullScreenElement',
  fullscreenEnabled: 'webkitCancelFullScreen',
  fullscreenchange: 'webkitfullscreenchange',
  fullscreenerror: 'webkitfullscreenerror'
},
// old firefox
{
  requestFullscreen: 'mozRequestFullScreen',
  exitFullscreen: 'mozCancelFullScreen',
  fullscreenElement: 'mozFullScreenElement',
  fullscreenEnabled: 'mozFullScreenEnabled',
  fullscreenchange: 'mozfullscreenchange',
  fullscreenerror: 'mozfullscreenerror'
},
// old IE
{
  requestFullscreen: 'msRequestFullscreen',
  exitFullscreen: 'msExitFullscreen',
  fullscreenElement: 'msFullscreenElement',
  fullscreenEnabled: 'msFullscreenEnabled',
  fullscreenchange: 'MSFullscreenChange',
  fullscreenerror: 'MSFullscreenError'
}];

// iOS API (on the video element itself!)
var iosMethods = {
  requestFullscreen: 'webkitEnterFullscreen',
  exitFullscreen: 'webkitExitFullscreen',
  fullscreenElement: null,
  fullscreenEnabled: 'webkitDisplayingFullscreen',
  fullscreenchange: 'fullscreenchange',
  fullscreenerror: 'fullscreenerror'
};
var isCurrentlyFullscreen = function isCurrentlyFullscreen(inputElement) {
  var _getFullscreenMethods = getFullscreenMethods(inputElement),
    methods = _getFullscreenMethods.methods,
    element = _getFullscreenMethods.element;
  if (methods !== null && methods !== void 0 && methods.fullscreenElement) {
    return Boolean(document[methods.fullscreenElement]);
  } else {
    // handle iOS API
    return Boolean((element === null || element === void 0 ? void 0 : element.webkitPresentationMode) === 'fullscreen');
  }
};
var enterFullscreen = function enterFullscreen(inputElement) {
  var _getFullscreenMethods2 = getFullscreenMethods(inputElement),
    methods = _getFullscreenMethods2.methods,
    element = _getFullscreenMethods2.element;
  if (methods) {
    return new Promise(function (resolve, reject) {
      var _element$parentElemen, _element$parentElemen2, _element$fullscreenMe, _element$fullscreenMe2;
      var fullscreenMethod = methods.requestFullscreen;
      var onFullScreen = function onFullScreen() {
        removeFullscreenEventListener(inputElement, onFullScreen);
        resolve();
      };
      addFullscreenEventListener(inputElement, onFullScreen);
      var returnPromise = methods.fullscreenElement ? element === null || element === void 0 ? void 0 : (_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : (_element$parentElemen2 = _element$parentElemen[fullscreenMethod]) === null || _element$parentElemen2 === void 0 ? void 0 : _element$parentElemen2.call(_element$parentElemen) : (_element$fullscreenMe = element === null || element === void 0 ? void 0 : (_element$fullscreenMe2 = element[fullscreenMethod]) === null || _element$fullscreenMe2 === void 0 ? void 0 : _element$fullscreenMe2.call(element)) !== null && _element$fullscreenMe !== void 0 ? _element$fullscreenMe : null;
      if (returnPromise === null) {
        return resolve();
      }
      if (returnPromise instanceof Promise) {
        returnPromise.then(onFullScreen).catch(reject);
      }
    });
  }
  return false;
};
var exitFullscreen = function exitFullscreen(inputElement) {
  var _getFullscreenMethods3 = getFullscreenMethods(inputElement),
    methods = _getFullscreenMethods3.methods,
    element = _getFullscreenMethods3.element;
  if (methods) {
    return new Promise(function (resolve, reject) {
      var _document, _document$methods$exi, _element$methods$exit, _element$methods$exit2;
      if (!isCurrentlyFullscreen(inputElement)) {
        resolve();
        return;
      }
      var onFullScreenExit = function onFullScreenExit() {
        removeFullscreenEventListener(inputElement, onFullScreenExit);
        resolve();
      };
      addFullscreenEventListener(inputElement, onFullScreenExit);
      var returnPromise = methods.fullscreenElement ? (_document = document) === null || _document === void 0 ? void 0 : (_document$methods$exi = _document[methods.exitFullscreen]) === null || _document$methods$exi === void 0 ? void 0 : _document$methods$exi.call(_document) : (_element$methods$exit = element === null || element === void 0 ? void 0 : (_element$methods$exit2 = element[methods.exitFullscreen]) === null || _element$methods$exit2 === void 0 ? void 0 : _element$methods$exit2.call(element)) !== null && _element$methods$exit !== void 0 ? _element$methods$exit : null;
      if (returnPromise instanceof Promise) {
        returnPromise.then(onFullScreenExit).catch(reject);
      }
    });
  }
  return false;
};
var addFullscreenEventListener = function addFullscreenEventListener(inputElement, callback) {
  var _getFullscreenMethods4 = getFullscreenMethods(inputElement),
    methods = _getFullscreenMethods4.methods,
    element = _getFullscreenMethods4.element;
  if (methods && element) {
    var _element$parentElemen3;
    var parentElementOrElement = (_element$parentElemen3 = element === null || element === void 0 ? void 0 : element.parentElement) !== null && _element$parentElemen3 !== void 0 ? _element$parentElemen3 : element;
    parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : parentElementOrElement.addEventListener(methods.fullscreenchange, callback, false);
    return function () {
      removeFullscreenEventListener(inputElement, callback);
    };
  }
  return null;
};
var removeFullscreenEventListener = function removeFullscreenEventListener(inputElement, callback) {
  var _getFullscreenMethods5 = getFullscreenMethods(inputElement),
    methods = _getFullscreenMethods5.methods,
    element = _getFullscreenMethods5.element;
  if (methods && element) {
    var _element$parentElemen4;
    var parentElementOrElement = (_element$parentElemen4 = element === null || element === void 0 ? void 0 : element.parentElement) !== null && _element$parentElemen4 !== void 0 ? _element$parentElemen4 : element;
    parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : parentElementOrElement.removeEventListener(methods.fullscreenchange, callback, false);
    return true;
  }
  return false;
};
var getFullscreenMethods = function getFullscreenMethods(element) {
  if (isClient()) {
    var _iterator = _createForOfIteratorHelper(methodsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var methods = _step.value;
        var exitFullscreenMethod = methods.exitFullscreen;
        if (exitFullscreenMethod in document) {
          return {
            methods: methods,
            element: element
          };
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (element && iosMethods.requestFullscreen in element) {
      return {
        methods: iosMethods,
        element: element
      };
    }
  }
  return {
    methods: null
  };
};

var isPictureInPictureSupported = function isPictureInPictureSupported(element) {
  var _getPictureInPictureM = getPictureInPictureMode(element),
    apiType = _getPictureInPictureM.apiType;
  return Boolean(apiType);
};
var isCurrentlyPictureInPicture = function isCurrentlyPictureInPicture(inputElement) {
  var _getPictureInPictureM2 = getPictureInPictureMode(inputElement),
    apiType = _getPictureInPictureM2.apiType,
    element = _getPictureInPictureM2.element;
  if (apiType === 'w3c') {
    var _document;
    return Boolean((_document = document) === null || _document === void 0 ? void 0 : _document.pictureInPictureElement);
  } else if (apiType === 'webkit') {
    return (element === null || element === void 0 ? void 0 : element.webkitPresentationMode) === 'picture-in-picture';
  }
  return false;
};
var enterPictureInPicture = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(inputElement) {
    var _getPictureInPictureM3, apiType, element, _element$requestPictu, _element$webkitSetPre;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getPictureInPictureM3 = getPictureInPictureMode(inputElement), apiType = _getPictureInPictureM3.apiType, element = _getPictureInPictureM3.element;
            _context.prev = 1;
            if (!(apiType === 'w3c')) {
              _context.next = 7;
              break;
            }
            _context.next = 5;
            return element === null || element === void 0 ? void 0 : (_element$requestPictu = element.requestPictureInPicture) === null || _element$requestPictu === void 0 ? void 0 : _element$requestPictu.call(element);
          case 5:
            _context.next = 10;
            break;
          case 7:
            if (!(apiType === 'webkit')) {
              _context.next = 10;
              break;
            }
            _context.next = 10;
            return element === null || element === void 0 ? void 0 : (_element$webkitSetPre = element.webkitSetPresentationMode) === null || _element$webkitSetPre === void 0 ? void 0 : _element$webkitSetPre.call(element, 'picture-in-picture');
          case 10:
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            console.warn(_context.t0);
          case 15:
            return _context.abrupt("return", null);
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function enterPictureInPicture(_x) {
    return _ref.apply(this, arguments);
  };
}();
var exitPictureInPicture = function exitPictureInPicture(inputElement) {
  var _getPictureInPictureM4 = getPictureInPictureMode(inputElement),
    apiType = _getPictureInPictureM4.apiType,
    element = _getPictureInPictureM4.element;
  if (apiType === 'w3c') {
    var _document$exitPicture, _document2, _document2$exitPictur;
    return (_document$exitPicture = (_document2 = document) === null || _document2 === void 0 ? void 0 : (_document2$exitPictur = _document2.exitPictureInPicture) === null || _document2$exitPictur === void 0 ? void 0 : _document2$exitPictur.call(_document2)) !== null && _document$exitPicture !== void 0 ? _document$exitPicture : null;
  } else if (apiType === 'webkit') {
    var _element$webkitSetPre2, _element$webkitSetPre3;
    return (_element$webkitSetPre2 = element === null || element === void 0 ? void 0 : (_element$webkitSetPre3 = element.webkitSetPresentationMode) === null || _element$webkitSetPre3 === void 0 ? void 0 : _element$webkitSetPre3.call(element, 'inline')) !== null && _element$webkitSetPre2 !== void 0 ? _element$webkitSetPre2 : null;
  }
  return null;
};
var addEnterPictureInPictureEventListener = function addEnterPictureInPictureEventListener(inputElement, callback) {
  var _getPictureInPictureM5 = getPictureInPictureMode(inputElement),
    apiType = _getPictureInPictureM5.apiType,
    element = _getPictureInPictureM5.element;
  if (apiType === 'w3c' && element) {
    element.addEventListener('enterpictureinpicture', callback, false);
    return function () {
      element.removeEventListener('enterpictureinpicture', callback, false);
    };
  }
  if (apiType === 'webkit' && element) {
    var callbackComposed = function callbackComposed(e) {
      if ((element === null || element === void 0 ? void 0 : element.webkitPresentationMode) === 'picture-in-picture') {
        callback === null || callback === void 0 ? void 0 : callback(e);
      }
    };
    document.addEventListener('webkitpresentationmodechanged', callbackComposed, false);
    return function () {
      document.removeEventListener('webkitpresentationmodechanged', callbackComposed, false);
    };
  }
  return null;
};
var addExitPictureInPictureEventListener = function addExitPictureInPictureEventListener(inputElement, callback) {
  var _getPictureInPictureM6 = getPictureInPictureMode(inputElement),
    apiType = _getPictureInPictureM6.apiType,
    element = _getPictureInPictureM6.element;
  if (apiType === 'w3c' && element) {
    element.addEventListener('leavepictureinpicture', callback, false);
    return function () {
      element.removeEventListener('leavepictureinpicture', callback, false);
    };
  }
  if (apiType === 'webkit' && element) {
    var callbackComposed = function callbackComposed(e) {
      if ((element === null || element === void 0 ? void 0 : element.webkitPresentationMode) === 'inline') {
        callback === null || callback === void 0 ? void 0 : callback(e);
      }
    };
    document.addEventListener('webkitpresentationmodechanged', callbackComposed, false);
    return function () {
      document.removeEventListener('webkitpresentationmodechanged', callbackComposed, false);
    };
  }
  return null;
};
var getPictureInPictureMode = function getPictureInPictureMode(element) {
  if (isClient() && element instanceof HTMLVideoElement) {
    var _document3, _element$webkitSuppor;
    // we disable the next line since we handle missing Safari versions in the next statement
    // eslint-disable-next-line compat/compat
    if ((_document3 = document) !== null && _document3 !== void 0 && _document3.pictureInPictureEnabled) {
      return {
        apiType: 'w3c',
        element: element
      };
    }

    // fallback to trying webkit
    if (element !== null && element !== void 0 && (_element$webkitSuppor = element.webkitSupportsPresentationMode) !== null && _element$webkitSuppor !== void 0 && _element$webkitSuppor.call(element, 'picture-in-picture')) {
      return {
        apiType: 'webkit',
        element: element
      };
    }
  }
  return {
    apiType: null
  };
};

var MEDIA_CONTROLLER_INITIALIZED_ATTRIBUTE = 'data-controller-initialized';
var allKeyTriggers = ['KeyF', 'KeyK', 'KeyM', 'KeyI', 'Space', 'ArrowRight', 'ArrowLeft'];
var DEFAULT_SEEK_TIME = 5000; // milliseconds which the media will skip when seeking with arrows/buttons
var DEFAULT_AUTOHIDE_TIME = 3000; // milliseconds to wait before hiding controls
var DEFAULT_VOLUME_LEVEL = 0.2; // 0-1 for how loud the audio is

var getFilteredNaN = function getFilteredNaN(value) {
  return value && !isNaN(value) && isFinite(value) ? value : 0;
};
var getBoundedSeek = function getBoundedSeek(seek, duration) {
  return Math.min(Math.max(0, getFilteredNaN(seek)),
  // seek to near the end
  getFilteredNaN(duration) ? getFilteredNaN(duration) - 0.01 : 0);
};
var getBoundedVolume = function getBoundedVolume(volume) {
  return Math.min(Math.max(0, getFilteredNaN(volume)), 1);
};

// if volume change is unsupported, the element will always return 1
// similar to https://github.com/videojs/video.js/pull/7514/files

var getIsVolumeChangeSupported = function getIsVolumeChangeSupported(element) {
  return new Promise(function (resolve) {
    var _element$volume;
    var prevVolume = (_element$volume = element === null || element === void 0 ? void 0 : element.volume) !== null && _element$volume !== void 0 ? _element$volume : DEFAULT_VOLUME_LEVEL;
    var newVolume = prevVolume - 0.01;

    // set new value and test
    element.volume = newVolume;
    window.setTimeout(function () {
      var isSupported = element.volume !== 1;

      // reset to old value
      element.volume = prevVolume;
      resolve(isSupported);
    });
  });
};
var createControllerStore = function createControllerStore(element, storage) {
  var store = create(persist(function (set, get) {
    var _element$volume2, _ref, _element$muted;
    return {
      _element: element,
      canPlay: false,
      hidden: false,
      live: false,
      hasPlayed: false,
      playing: !(element !== null && element !== void 0 && element.paused),
      fullscreen: false,
      pictureInPicture: false,
      device: {
        isMobile: isMobile(),
        isIos: isIos(),
        isAndroid: isAndroid()
      },
      progress: getFilteredNaN(element === null || element === void 0 ? void 0 : element.currentTime),
      duration: getFilteredNaN(element === null || element === void 0 ? void 0 : element.duration),
      buffered: 0,
      volume: (_element$volume2 = element === null || element === void 0 ? void 0 : element.volume) !== null && _element$volume2 !== void 0 ? _element$volume2 : DEFAULT_VOLUME_LEVEL,
      muted: (_ref = (_element$muted = element === null || element === void 0 ? void 0 : element.muted) !== null && _element$muted !== void 0 ? _element$muted : element === null || element === void 0 ? void 0 : element.defaultMuted) !== null && _ref !== void 0 ? _ref : true,
      isVolumeChangeSupported: false,
      _lastInteraction: Date.now(),
      _requestedRangeToSeekTo: 0,
      _requestedFullscreenLastTime: Date.now(),
      _requestedPictureInPictureLastTime: Date.now(),
      setHidden: function setHidden(hidden) {
        return set(function (_ref2) {
          var playing = _ref2.playing;
          return {
            hidden: playing ? hidden : false
          };
        });
      },
      _updateLastInteraction: function _updateLastInteraction() {
        return set(function () {
          return {
            _lastInteraction: Date.now()
          };
        });
      },
      onCanPlay: function onCanPlay() {
        return set(function () {
          return {
            canPlay: true
          };
        });
      },
      onPlay: function onPlay() {
        return set(function () {
          return {
            playing: true,
            _lastInteraction: Date.now(),
            hasPlayed: true
          };
        });
      },
      onPause: function onPause() {
        return set(function () {
          return {
            playing: false,
            hidden: false
          };
        });
      },
      togglePlay: function togglePlay() {
        var _store$getState = store.getState(),
          hidden = _store$getState.hidden,
          setHidden = _store$getState.setHidden,
          device = _store$getState.device;
        if (hidden && device.isMobile) {
          setHidden(false);
        } else {
          set(function (_ref3) {
            var playing = _ref3.playing;
            return {
              playing: !playing
            };
          });
        }
      },
      onProgress: function onProgress(time) {
        return set(function () {
          return {
            progress: getFilteredNaN(time)
          };
        });
      },
      requestSeek: function requestSeek(time) {
        return set(function (_ref4) {
          var duration = _ref4.duration;
          return {
            _requestedRangeToSeekTo: getBoundedSeek(time, duration),
            progress: getBoundedSeek(time, duration)
          };
        });
      },
      onDurationChange: function onDurationChange(duration) {
        return set(function (_ref5) {
          var live = _ref5.live;
          return {
            duration: duration,
            live: duration === Number.POSITIVE_INFINITY ? true : live
          };
        });
      },
      _updateBuffered: function _updateBuffered(buffered) {
        return set(function () {
          return {
            buffered: buffered
          };
        });
      },
      _requestSeekDiff: function _requestSeekDiff(difference) {
        return set(function (_ref6) {
          var _element$currentTime;
          var duration = _ref6.duration;
          return {
            _requestedRangeToSeekTo: getBoundedSeek(getFilteredNaN((_element$currentTime = element === null || element === void 0 ? void 0 : element.currentTime) !== null && _element$currentTime !== void 0 ? _element$currentTime : 0) + difference / 1000, duration)
          };
        });
      },
      requestSeekBack: function requestSeekBack() {
        var difference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SEEK_TIME;
        return get()._requestSeekDiff(-difference);
      },
      requestSeekForward: function requestSeekForward() {
        var difference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SEEK_TIME;
        return get()._requestSeekDiff(difference);
      },
      setFullscreen: function setFullscreen(fullscreen) {
        return set(function () {
          return {
            fullscreen: fullscreen
          };
        });
      },
      requestToggleFullscreen: function requestToggleFullscreen() {
        return set(function () {
          return {
            _requestedFullscreenLastTime: Date.now()
          };
        });
      },
      setPictureInPicture: function setPictureInPicture(pictureInPicture) {
        return set(function () {
          return {
            pictureInPicture: pictureInPicture
          };
        });
      },
      requestTogglePictureInPicture: function requestTogglePictureInPicture() {
        return set(function () {
          return {
            _requestedPictureInPictureLastTime: Date.now()
          };
        });
      },
      setLive: function setLive(live) {
        return set(function () {
          return {
            live: live
          };
        });
      },
      requestVolume: function requestVolume(newVolume) {
        return set(function (_ref7) {
          var volume = _ref7.volume;
          return {
            volume: newVolume === 0 ? volume : getBoundedVolume(newVolume),
            muted: newVolume === 0
          };
        });
      },
      _setVolume: function _setVolume(newVolume) {
        return set(function () {
          return {
            volume: getBoundedVolume(newVolume)
          };
        });
      },
      requestToggleMute: function requestToggleMute() {
        return set(function (_ref8) {
          var muted = _ref8.muted;
          return {
            muted: !muted
          };
        });
      },
      setIsVolumeChangeSupported: function setIsVolumeChangeSupported(supported) {
        return set(function () {
          return {
            isVolumeChangeSupported: supported
          };
        });
      }
    };
  }, {
    name: 'livepeer-player',
    version: 1,
    // since these values are persisted across media elements, only persist volume
    partialize: function partialize(_ref9) {
      var volume = _ref9.volume;
      return {
        volume: volume
      };
    },
    getStorage: function getStorage() {
      return storage !== null && storage !== void 0 ? storage : createStorage({
        storage: noopStorage
      });
    }
  }));
  var initializedState = store.getState();

  // restore the persisted values from store
  if (element && !element.muted && !element.defaultMuted) {
    element.volume = initializedState.volume;
  }
  return store;
};
var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var addEventListeners = function addEventListeners(store) {
  var _store$getState2;
  var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref10$hotkeys = _ref10.hotkeys,
    hotkeys = _ref10$hotkeys === void 0 ? true : _ref10$hotkeys,
    _ref10$autohide = _ref10.autohide,
    autohide = _ref10$autohide === void 0 ? DEFAULT_AUTOHIDE_TIME : _ref10$autohide;
  var element = store === null || store === void 0 ? void 0 : (_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : _store$getState2._element;
  var onCanPlay = function onCanPlay() {
    return store.getState().onCanPlay();
  };
  var onPlay = function onPlay() {
    return store.getState().onPlay();
  };
  var onPause = function onPause() {
    return store.getState().onPause();
  };
  var onDurationChange = function onDurationChange() {
    var _element$duration;
    return store.getState().onDurationChange((_element$duration = element === null || element === void 0 ? void 0 : element.duration) !== null && _element$duration !== void 0 ? _element$duration : 0);
  };
  var onTimeUpdate = function onTimeUpdate() {
    var _element$currentTime2;
    return store.getState().onProgress((_element$currentTime2 = element === null || element === void 0 ? void 0 : element.currentTime) !== null && _element$currentTime2 !== void 0 ? _element$currentTime2 : 0);
  };
  var onKeyUp = function onKeyUp(e) {
    e.preventDefault();
    e.stopPropagation();
    var code = e.code;
    store.getState()._updateLastInteraction();
    if (allKeyTriggers.includes(code)) {
      if (code === 'Space' || code === 'KeyK') {
        store.getState().togglePlay();
      } else if (code === 'KeyF') {
        store.getState().requestToggleFullscreen();
      } else if (code === 'KeyI') {
        store.getState().requestTogglePictureInPicture();
      } else if (code === 'ArrowRight') {
        store.getState().requestSeekForward();
      } else if (code === 'ArrowLeft') {
        store.getState().requestSeekBack();
      } else if (code === 'KeyM') {
        store.getState().requestToggleMute();
      }
    }
  };
  var onMouseEnter = function onMouseEnter() {
    store.getState()._updateLastInteraction();
  };
  var onMouseLeave = function onMouseLeave() {
    if (autohide) {
      store.getState().setHidden(true);
    }
  };
  var onMouseMove = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.getState()._updateLastInteraction();
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onMouseMove() {
      return _ref11.apply(this, arguments);
    };
  }();
  var onTouchUpdate = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              store.getState()._updateLastInteraction();
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function onTouchUpdate() {
      return _ref12.apply(this, arguments);
    };
  }();
  var onVolumeChange = function onVolumeChange() {
    if (typeof (element === null || element === void 0 ? void 0 : element.volume) !== 'undefined' && (element === null || element === void 0 ? void 0 : element.volume) !== store.getState().volume) {
      store.getState()._setVolume(element.volume);
    }
  };
  var onProgress = function onProgress() {
    var _element$duration2;
    if (element && ((_element$duration2 = element === null || element === void 0 ? void 0 : element.duration) !== null && _element$duration2 !== void 0 ? _element$duration2 : 0) > 0) {
      var _store$getState$durat, _store$getState3, _store$getState3$call;
      var currentTime = element.currentTime;
      var _buffered = _toConsumableArray(Array(element.buffered.length)).reduce(function (prev, _curr, i) {
        var start = element.buffered.start(element.buffered.length - 1 - i);
        var end = element.buffered.end(element.buffered.length - 1 - i);

        // if the TimeRange covers the current time, then use this value
        if (start <= currentTime && end >= currentTime) {
          return end;
        }
        return prev;
      }, // default to end of media
      (_store$getState$durat = store === null || store === void 0 ? void 0 : (_store$getState3 = store.getState) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$call = _store$getState3.call(store)) === null || _store$getState3$call === void 0 ? void 0 : _store$getState3$call.duration) !== null && _store$getState$durat !== void 0 ? _store$getState$durat : 0);
      store.getState()._updateBuffered(_buffered);
    }
  };
  var retryCount = 0;
  var onError = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return new Promise(function (r) {
                return setTimeout(r, 1000 * ++retryCount);
              });
            case 2:
              element === null || element === void 0 ? void 0 : element.load();
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function onError() {
      return _ref13.apply(this, arguments);
    };
  }();
  if (element) {
    var _element$parentElemen;
    element.addEventListener('volumechange', onVolumeChange);
    element.addEventListener('canplay', onCanPlay);
    element.addEventListener('play', onPlay);
    element.addEventListener('pause', onPause);
    element.addEventListener('durationchange', onDurationChange);
    element.addEventListener('timeupdate', onTimeUpdate);
    element.addEventListener('progress', onProgress);
    element.addEventListener('error', onError);
    var parentElementOrElement = (_element$parentElemen = element === null || element === void 0 ? void 0 : element.parentElement) !== null && _element$parentElemen !== void 0 ? _element$parentElemen : element;
    if (hotkeys) {
      parentElementOrElement.addEventListener('keyup', onKeyUp);
    }
    if (autohide) {
      parentElementOrElement.addEventListener('mouseenter', onMouseEnter);
      parentElementOrElement.addEventListener('mouseleave', onMouseLeave);
      parentElementOrElement.addEventListener('mousemove', onMouseMove);
      parentElementOrElement.addEventListener('touchstart', onTouchUpdate);
      parentElementOrElement.addEventListener('touchend', onTouchUpdate);
      parentElementOrElement.addEventListener('touchmove', onTouchUpdate);
    }
    element.load();
    getIsVolumeChangeSupported(element).then(function (isVolumeChangeSupported) {
      return store.getState().setIsVolumeChangeSupported(isVolumeChangeSupported);
    });
    element.setAttribute(MEDIA_CONTROLLER_INITIALIZED_ATTRIBUTE, 'true');
  }
  var onFullscreenChange = function onFullscreenChange() {
    store.getState().setFullscreen(isCurrentlyFullscreen(element));
  };
  var onEnterPictureInPicture = function onEnterPictureInPicture() {
    store.getState().setPictureInPicture(true);
  };
  var onExitPictureInPicture = function onExitPictureInPicture() {
    store.getState().setPictureInPicture(false);
  };

  // add effects
  var removeEffectsFromStore = addEffectsToStore(store, element, {
    autohide: autohide
  });

  // add fullscreen listener
  var removeFullscreenListener = addFullscreenEventListener(element, onFullscreenChange);

  // add picture in picture listeners
  var removeEnterPictureInPictureListener = addEnterPictureInPictureEventListener(element, onEnterPictureInPicture);
  var removeExitPictureInPictureListener = addExitPictureInPictureEventListener(element, onExitPictureInPicture);
  return {
    destroy: function destroy() {
      var _element$removeEventL, _element$removeEventL2, _element$removeEventL3, _element$removeEventL4, _element$removeEventL5, _element$removeEventL6, _element$parentElemen2, _parentElementOrEleme, _parentElementOrEleme2, _parentElementOrEleme3, _parentElementOrEleme4, _parentElementOrEleme5, _parentElementOrEleme6, _parentElementOrEleme7, _store$destroy, _element$removeAttrib;
      removeFullscreenListener === null || removeFullscreenListener === void 0 ? void 0 : removeFullscreenListener();
      removeEnterPictureInPictureListener === null || removeEnterPictureInPictureListener === void 0 ? void 0 : removeEnterPictureInPictureListener();
      removeExitPictureInPictureListener === null || removeExitPictureInPictureListener === void 0 ? void 0 : removeExitPictureInPictureListener();
      element === null || element === void 0 ? void 0 : (_element$removeEventL = element.removeEventListener) === null || _element$removeEventL === void 0 ? void 0 : _element$removeEventL.call(element, 'canplay', onCanPlay);
      element === null || element === void 0 ? void 0 : (_element$removeEventL2 = element.removeEventListener) === null || _element$removeEventL2 === void 0 ? void 0 : _element$removeEventL2.call(element, 'play', onPlay);
      element === null || element === void 0 ? void 0 : (_element$removeEventL3 = element.removeEventListener) === null || _element$removeEventL3 === void 0 ? void 0 : _element$removeEventL3.call(element, 'pause', onPause);
      element === null || element === void 0 ? void 0 : (_element$removeEventL4 = element.removeEventListener) === null || _element$removeEventL4 === void 0 ? void 0 : _element$removeEventL4.call(element, 'durationchange', onDurationChange);
      element === null || element === void 0 ? void 0 : (_element$removeEventL5 = element.removeEventListener) === null || _element$removeEventL5 === void 0 ? void 0 : _element$removeEventL5.call(element, 'timeupdate', onTimeUpdate);
      element === null || element === void 0 ? void 0 : (_element$removeEventL6 = element.removeEventListener) === null || _element$removeEventL6 === void 0 ? void 0 : _element$removeEventL6.call(element, 'progress', onProgress);
      var parentElementOrElement = (_element$parentElemen2 = element === null || element === void 0 ? void 0 : element.parentElement) !== null && _element$parentElemen2 !== void 0 ? _element$parentElemen2 : element;
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme === void 0 ? void 0 : _parentElementOrEleme.call(parentElementOrElement, 'keyup', onKeyUp);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme2 = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme2 === void 0 ? void 0 : _parentElementOrEleme2.call(parentElementOrElement, 'mouseenter', onMouseEnter);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme3 = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme3 === void 0 ? void 0 : _parentElementOrEleme3.call(parentElementOrElement, 'mouseleave', onMouseLeave);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme4 = parentElementOrElement.removeEventListener) === null || _parentElementOrEleme4 === void 0 ? void 0 : _parentElementOrEleme4.call(parentElementOrElement, 'mousemove', onMouseMove);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme5 = parentElementOrElement.addEventListener) === null || _parentElementOrEleme5 === void 0 ? void 0 : _parentElementOrEleme5.call(parentElementOrElement, 'touchstart', onTouchUpdate);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme6 = parentElementOrElement.addEventListener) === null || _parentElementOrEleme6 === void 0 ? void 0 : _parentElementOrEleme6.call(parentElementOrElement, 'touchend', onTouchUpdate);
      parentElementOrElement === null || parentElementOrElement === void 0 ? void 0 : (_parentElementOrEleme7 = parentElementOrElement.addEventListener) === null || _parentElementOrEleme7 === void 0 ? void 0 : _parentElementOrEleme7.call(parentElementOrElement, 'touchmove', onTouchUpdate);
      removeEffectsFromStore === null || removeEffectsFromStore === void 0 ? void 0 : removeEffectsFromStore();
      store === null || store === void 0 ? void 0 : (_store$destroy = store.destroy) === null || _store$destroy === void 0 ? void 0 : _store$destroy.call(store);
      element === null || element === void 0 ? void 0 : (_element$removeAttrib = element.removeAttribute) === null || _element$removeAttrib === void 0 ? void 0 : _element$removeAttrib.call(element, MEDIA_CONTROLLER_INITIALIZED_ATTRIBUTE);
    }
  };
};
var previousPromise;
var addEffectsToStore = function addEffectsToStore(store, element, options) {
  // add effects to store changes
  return store.subscribe( /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(current, prev) {
      var _store$getState4, device, isFullscreen, isPictureInPicture;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (!element) {
                _context4.next = 23;
                break;
              }
              if (!previousPromise) {
                _context4.next = 11;
                break;
              }
              _context4.prev = 3;
              _context4.next = 6;
              return previousPromise;
            case 6:
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](3);
              console.warn(_context4.t0);
            case 11:
              if (current.playing !== prev.playing) {
                if (current.playing) {
                  previousPromise = element.play();
                } else {
                  element.pause();
                }
              }
              if (current.volume !== prev.volume) {
                element.volume = current.volume;
              }
              if (current.muted !== prev.muted) {
                element.muted = current.muted;
                if (current.volume === 0) {
                  element.volume = DEFAULT_VOLUME_LEVEL;
                }
              }
              if (current._requestedRangeToSeekTo !== prev._requestedRangeToSeekTo) {
                // Can't set the time before the media is ready
                // Ignore if readyState isn't supported
                if (typeof element.readyState === 'undefined' || element.readyState > 0) {
                  element.currentTime = current._requestedRangeToSeekTo;
                }
              }

              // user has interacted with element
              if (!(options.autohide && current._lastInteraction !== prev._lastInteraction)) {
                _context4.next = 21;
                break;
              }
              _store$getState4 = store.getState(), device = _store$getState4.device;
              if (!device.isMobile) {
                store.getState().setHidden(false);
              }
              _context4.next = 20;
              return delay(options.autohide);
            case 20:
              if (!store.getState().hidden && current._lastInteraction === store.getState()._lastInteraction) {
                store.getState().setHidden(true);
              }
            case 21:
              if (current._requestedFullscreenLastTime !== prev._requestedFullscreenLastTime) {
                isFullscreen = isCurrentlyFullscreen(element);
                if (!isFullscreen) {
                  previousPromise = enterFullscreen(element);
                } else {
                  previousPromise = exitFullscreen(element);
                }
              }
              if (current._requestedPictureInPictureLastTime !== prev._requestedPictureInPictureLastTime) {
                isPictureInPicture = isCurrentlyPictureInPicture(element);
                if (!isPictureInPicture) {
                  previousPromise = enterPictureInPicture(element);
                } else {
                  previousPromise = exitPictureInPicture(element);
                }
              }
            case 23:
              _context4.next = 28;
              break;
            case 25:
              _context4.prev = 25;
              _context4.t1 = _context4["catch"](0);
              console.warn(_context4.t1);
            case 28:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 25], [3, 8]]);
    }));
    return function (_x, _x2) {
      return _ref14.apply(this, arguments);
    };
  }());
};

export { addEventListeners, createControllerStore, isPictureInPictureSupported };
